import React from "react";
import PropTypes from "prop-types";
import { Button } from "@learningblocks/shared-components";

import cn from "./style.module.scss";

export function OptionsSelectButton(props) {
  const className = `${cn.optionSelectButton} ${props.className}`;
  return (
    <Button onClick={props.onClick} className={className}>
      {props.text}
    </Button>
  );
}

OptionsSelectButton.propTypes = {
  /**
   * className of the OptionsSelectButton
   */
  className: PropTypes.string,
  /**
   * text to be rendered inside of the button
   */
  text: PropTypes.string,
  /**
   * function to invoke on click
   */
  onClick: PropTypes.func,
};

OptionsSelectButton.defaultProps = {
  className: "",
};
